import { createSelectorCreator, defaultMemoize } from "reselect";

import isEqual from "lodash/isEqual";

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, isEqual);

export const systemHealthSelector = createDeepEqualSelector(
    [
		state => state.systemHealth.clusterHealth,
		state => state.systemHealth.health
	],
	(clusterHealth, health) => {
		return {...clusterHealth, ...health};
	}
);